module.exports = __webpack_public_path__ + "img/t_0035.38494013.gif";